import styled from "styled-components";

export const StyledProductTags = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
`;

export const StyledProductTag = styled.div`
    padding: 2px 7px;
    border-radius: 12px;
    font-family: Inter;
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    letter-spacing: 0%;
    min-height: 20px;
    max-height: 20px;
`;

export const StyledProductTagNew = styled(StyledProductTag)`
    color: #ffffff;
    background-color: #d32029;
`;

export const StyledProductTagSpecial = styled(StyledProductTag)`
    color: #3c89e8;
    background-color: #15325b;
`;

export const StyledProductTagDropout = styled(StyledProductTag)`
    color: #ab7ae0;
    background-color: #301c4d;
`;

export const StyledProductTagMML = styled(StyledProductTag)`
    color: #d87a16;
    background-color: #313131;
`;
